import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-icon-prev',
	templateUrl: './prev.component.html',
	styleUrls: ['./prev.component.scss']
})
export class PrevComponent {}
